 
<div class="container">
  <section>
    <div class="scrollmenu">
      <a [routerLink]="['/pos/businessinfo']"> Business-info </a>
      <a [routerLink]="['/pos/customer/manage']"> Customer </a>
      <a [routerLink]="['/pos/employee/manage']"> Employee </a>
      <a [routerLink]="['/pos/orders/manage']"> Orders </a>
      <a [routerLink]="['/pos/taxfee/manage']"> Tax-Fee </a>
      <a [routerLink]="['/pos/category/manage']"> Item-Category </a>
      <a [routerLink]="['/pos/item/manage']">Items </a>
      <a [routerLink]="['/pos/businesshour/manage']"> Business-Hours </a>
  </div>

  </section>

  <div class="card card-outline-secondary mt-2">
    <!-- <div class="card-header blue-bg">
        
        <h3 class="mb-0">Pos</h3>
    </div> -->
    <div class="card-body shadow right-img">

        <div class="row m-0">
            <div class="col-md-9    bg-light">
              
                <h4 class="my-3 py-3 text-dark"><b>About Pos</b></h4>


                <p>1)	Click on Business info and update the required field. </p>
                <p>2)	Under Tax fees, you can create a tax fee by entering a tax fee name & tax rate.  </p>
                <p>3)	Under item category, you can categorize the items by entering the category name, select tax type from the drop down & enter the HSN code.</p>
                <p>4)	Under Items, you can create a new item by entering the required fields. Also select the price type (fixed, variable & per unit), enter product code as well after that you can submit the data. </p>
                <p>5)	By clicking on Business Hours, you can create a business schedule here.  </p>
                <p>6)	By clicking on Customer, you can create & submit your customer data here.</p>
                <p>7)	By clicking on Employee, you can create & submit your employee data here.</p>
            


            </div>
        </div>



        <div class="row m-0">
          <div class="col-md-9    bg-light">
            
              <h4 class="my-3 py-3 text-dark"><b>How to Create Order</b></h4>


              <p>1)	Go to Point of sale and click Orders </p>
              <p>2)	Select items from the given item-category  </p>
              <p>3)	After selecting items, enter customer details & shipping address of the customer</p>
              <p>4)	Customer will receive the Order details via e-mail & SMS, from there they can directly pay the amount  </p>
              <p>5)	FOR CASH- OR, after selecting items, enter customer details & shipping address of the customer and then select for cash option, in this scenario customer will going to do the cash payment.</p>
             
          </div>
      </div>


      <div class="row m-0">
        <div class="col-md-9    bg-light">
          
            <h5 class="my-3 py-3 text-dark"><b>Under POS dashboard merchant can view their Pending Order List as well as Completed Order List</b></h5>

        </div>
    </div>

    </div>
</div>

</div>
